module.exports = __webpack_public_path__ + "static/media/liveRoute.2f1ade75.svg";